var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEMail = function SvgEMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.d{fill:none;stroke:#171926;stroke-width:2px;}.c{stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(-23882 -22606)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23882 22606)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23880 -22605)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-23460-22473h24v18h-24Z",
    transform: "translate(23460 22473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.471,9.389.982,1.824A2.936,2.936,0,0,1,0,0H23.785A2.936,2.936,0,0,1,22.8,1.824L14.318,9.389a3.731,3.731,0,0,1-4.848,0Z",
    transform: "translate(0.154 0.002)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "d",
    y1: 9,
    x2: 9,
    transform: "translate(1 14.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 9,
    y1: 9,
    transform: "translate(16 14.5)"
  })))));
};
export default SvgEMail;